var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab',{style:(_vm.style)},[_vm._v(_vm._s(_vm.configuration.name))])}
var staticRenderFns = []

export { render, staticRenderFns }